module.exports = __webpack_public_path__ + "static/img/ind_ban_013.8766a7ac.jpeg";